export const CONTEXT_SORT_TITLE = [
  {
    id: 0,
    name: '平日'
  },
  {
    id: 1,
    name: '休日'
  },
  {
    id: 2,
    name: '期間'
  }
];

export const MODEL_SORT_KEY = [
  'nohinkaishibi',
  'brand_display_name',
  'type_display_name'
];
